
// import React, { useMemo } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
// import { useFetchData } from "../../../../hooks/useFtechData";
// import { JOBSEEKER_URL } from "../../../../resources/resource";
// import ApplicationTable from "../../Application";
// import  { Card, CardHeader, CardTitle, CardContent } from "../../../job/Crad";

// const Applications = () => {
//   const dispatch = useDispatch();
//   const { currentUser, token } = useSelector((state) => state.user);
//   const loggedInUser = useSelector((state) => state.user);
  
//   const { data: userDetails, refetch: refetchUser } = useFetchData(
//     JOBSEEKER_URL + `/getAjobSeeker/${loggedInUser?.currentUser?._id}`
//   );
//   const userId = localStorage.getItem('userId');
//   console.log(userId);

//   const userApplication = userDetails?.appliedJobs || [];

//   // Compute real analytics data from userApplication without changing structure
//   const analyticsData = useMemo(() => {
//     // Group by month for line/bar charts (applications over time)
//     const monthlyData = {};
//     userApplication.forEach(app => {
//       const date = new Date(app.createdAt);
//       const monthKey = date.toLocaleString('default', { month: 'short' }); // Jan, Feb, etc.
//       if (!monthlyData[monthKey]) {
//         monthlyData[monthKey] = { name: monthKey, applications: 0, interviews: 0 };
//       }
//       monthlyData[monthKey].applications += 1;
//       if (app.status?.toLowerCase() === 'scheduled' || app.status?.toLowerCase() === 'interviewed') {
//         monthlyData[monthKey].interviews += 1;
//       }
//     });
//     return Object.values(monthlyData).sort((a, b) => {
//       const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//       return months.indexOf(a.name) - months.indexOf(b.name);
//     });
//   }, [userApplication]);

//   const pieData = useMemo(() => {
//     const statusCounts = {
//       Applied: 0,
//       Shortlisted: 0,
//       Scheduled: 0,
//       Interviewed: 0,
//       Rejected: 0,
//       Hired: 0,
//     };
//     userApplication.forEach(app => {
//       const status = app.status?.toLowerCase();
//       if (status === 'applied') statusCounts.Applied += 1;
//       else if (status === 'shortlisted') statusCounts.Shortlisted += 1;
//       else if (status === 'scheduled') statusCounts.Scheduled += 1;
//       else if (status === 'interviewed') statusCounts.Interviewed += 1;
//       else if (status === 'rejected') statusCounts.Rejected += 1;
//       else if (status === 'offer' || status === 'accepted') statusCounts.Hired += 1;
//     });
//     return [
//       { name: 'Applied', value: statusCounts.Applied, color: '#f97316' }, // orange-500
//       { name: 'Shortlisted', value: statusCounts.Shortlisted, color: '#fb923c' }, // orange-400
//       { name: 'Scheduled', value: statusCounts.Scheduled, color: '#436508FF' }, // lighter orange
//       { name: 'Interviewed', value: statusCounts.Interviewed, color: '#187F2DFF' },
//       { name: 'Rejected', value: statusCounts.Rejected, color: '#C13924FF' }, // blue for contrast
//       { name: 'Hired', value: statusCounts.Hired, color: '#0909CAFF' }, // white
//     ].filter(item => item.value > 0); // Only show slices with data
//   }, [userApplication]);

//   const performanceMetrics = useMemo(() => {
//     const total = userApplication.length;
//     if (total === 0) return { acceptanceRate: '0%', responseTime: 'N/A', satisfaction: 'N/A' };
    
//     const hired = userApplication.filter(app => app.status?.toLowerCase() === 'offer' || app.status?.toLowerCase() === 'accepted').length;
//     const acceptanceRate = ((hired / total) * 100).toFixed(1) + '%';
    
//     // Mock/average response time (in days) - assuming some logic; here average days from applied to update
//     const avgResponseDays = userApplication.reduce((acc, app) => {
//       if (app.updatedAt && app.createdAt) {
//         const days = (new Date(app.updatedAt) - new Date(app.createdAt)) / (1000 * 60 * 60 * 24);
//         return acc + days;
//       }
//       return acc;
//     }, 0) / total || 0;
//     const responseTime = avgResponseDays.toFixed(1) + ' days';
    
//     // Mock satisfaction based on positive outcomes
//     const satisfaction = hired > 0 ? '4.8/5' : 'N/A';
    
//     return { acceptanceRate, responseTime, satisfaction };
//   }, [userApplication]);

//   return (
//     <div>
//       <div className="space-y-6 mt-8 md:overflow-x-hidden overflow-x-auto">
//           <h2 className="text-3xl font-bold text-gray-800">Analytics Overview</h2>
          
//           {/* Pie Chart for Status Distribution */}
//           {pieData.length > 0 && (
//             <div className="bg-white rounded-xl shadow-lg p-6">
//               <h3 className="text-xl font-semibold mb-4 text-gray-800">Application Status Distribution</h3>
//               <div className="h-64">
//                 <ResponsiveContainer width="100%" height="100%">
//                   <PieChart>
//                     <Pie
//                       data={pieData}
//                       cx="50%"
//                       cy="50%"
//                       labelLine={false}
//                       label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
//                       outerRadius={80}
//                       fill="#8884d8"
//                       dataKey="value"
//                     >
//                       {pieData.map((entry, index) => (
//                         <Cell key={`cell-${index}`} fill={entry.color} />
//                       ))}
//                     </Pie>
//                     <Tooltip />
//                   </PieChart>
//                 </ResponsiveContainer>
//               </div>
//             </div>
//           )}
          
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//             <div className="bg-white rounded-xl shadow-lg p-6">
//               <h3 className="text-xl font-semibold mb-4 text-gray-800">Applications Trends (Monthly)</h3>
//               <div className="h-64">
//                 <ResponsiveContainer width="100%" height="100%">
//                   <LineChart data={analyticsData}>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="name" />
//                     <YAxis />
//                     <Tooltip />
//                     <Legend />
//                     <Line type="monotone" dataKey="applications" stroke="#f97316" strokeWidth={2} />
//                   </LineChart>
//                 </ResponsiveContainer>
//               </div>
//             </div>
//             <div className="bg-white rounded-xl shadow-lg p-6">
//               <h3 className="text-xl font-semibold mb-4 text-gray-800">Interviews Growth (Monthly)</h3>
//               <div className="h-64">
//                 <ResponsiveContainer width="100%" height="100%">
//                   <BarChart data={analyticsData}>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="name" />
//                     <YAxis />
//                     <Tooltip />
//                     <Legend />
//                     <Bar dataKey="interviews" fill="#f97316" />
//                   </BarChart>
//                 </ResponsiveContainer>
//               </div>
//             </div>
//           </div>
          
//           <div className="bg-white rounded-xl shadow-lg p-6">
//             <h3 className="text-xl font-semibold mb-4 text-gray-800">Performance Metrics</h3>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//               <div className="text-center">
//                 <p className="text-3xl font-bold text-orange-500">{performanceMetrics.acceptanceRate}</p>
//                 <p className="text-gray-600">Acceptance Rate</p>
//               </div>
//               <div className="text-center">
//                 <p className="text-3xl font-bold text-orange-500">{performanceMetrics.responseTime}</p>
//                 <p className="text-gray-600">Avg. Response Time</p>
//               </div>
//               <div className="text-center">
//                 <p className="text-3xl font-bold text-orange-500">{performanceMetrics.satisfaction}</p>
//                 <p className="text-gray-600">Success Score</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
//         <ApplicationTable userApplication={userApplication} />
        
      
//       </div>
//     </div>
//   );
// }

// export default Applications;











import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { useFetchData } from "../../../../hooks/useFtechData";
import { JOBSEEKER_URL } from "../../../../resources/resource";
import ApplicationTable from "../../Application";
import { Card, CardHeader, CardTitle, CardContent } from "../../../job/Crad";

const Applications = () => {
  const dispatch = useDispatch();
  const { currentUser, token } = useSelector((state) => state.user);
  const loggedInUser = useSelector((state) => state.user);
  
  const { data: userDetails, refetch: refetchUser } = useFetchData(
    JOBSEEKER_URL + `/getAjobSeeker/${loggedInUser?.currentUser?._id}`
  );
  const userId = localStorage.getItem('userId');
  console.log(userId);

  const userApplication = userDetails?.appliedJobs || [];

  // Compute real analytics data from userApplication without changing structure
  const analyticsData = useMemo(() => {
    const monthlyData = {};
    userApplication.forEach(app => {
      const date = new Date(app.createdAt);
      const monthKey = date.toLocaleString('default', { month: 'short' });
      if (!monthlyData[monthKey]) {
        monthlyData[monthKey] = { name: monthKey, applications: 0, interviews: 0 };
      }
      monthlyData[monthKey].applications += 1;
      if (app.status?.toLowerCase() === 'scheduled' || app.status?.toLowerCase() === 'interviewed') {
        monthlyData[monthKey].interviews += 1;
      }
    });
    return Object.values(monthlyData).sort((a, b) => {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return months.indexOf(a.name) - months.indexOf(b.name);
    });
  }, [userApplication]);

  const pieData = useMemo(() => {
    const statusCounts = {
      Applied: 0, Shortlisted: 0, Scheduled: 0, Interviewed: 0, Rejected: 0, Hired: 0,
    };
    userApplication.forEach(app => {
      const status = app.status?.toLowerCase();
      if (status === 'applied') statusCounts.Applied += 1;
      else if (status === 'shortlisted') statusCounts.Shortlisted += 1;
      else if (status === 'scheduled') statusCounts.Scheduled += 1;
      else if (status === 'interviewed') statusCounts.Interviewed += 1;
      else if (status === 'rejected') statusCounts.Rejected += 1;
      else if (status === 'offer' || status === 'accepted') statusCounts.Hired += 1;
    });
    return [
      { name: 'Applied', value: statusCounts.Applied, color: '#f97316' },
      { name: 'Shortlisted', value: statusCounts.Shortlisted, color: '#fb923c' },
      { name: 'Scheduled', value: statusCounts.Scheduled, color: '#436508FF' },
      { name: 'Interviewed', value: statusCounts.Interviewed, color: '#187F2DFF' },
      { name: 'Rejected', value: statusCounts.Rejected, color: '#C13924FF' },
      { name: 'Hired', value: statusCounts.Hired, color: '#0909CAFF' },
    ].filter(item => item.value > 0);
  }, [userApplication]);

  const performanceMetrics = useMemo(() => {
    const total = userApplication.length;
    if (total === 0) return { acceptanceRate: '0%', responseTime: 'N/A', satisfaction: 'N/A' };
    
    const hired = userApplication.filter(app => 
      app.status?.toLowerCase() === 'offer' || app.status?.toLowerCase() === 'accepted'
    ).length;
    
    const acceptanceRate = ((hired / total) * 100).toFixed(1) + '%';
    
    const avgResponseDays = userApplication.reduce((acc, app) => {
      if (app.updatedAt && app.createdAt) {
        const days = (new Date(app.updatedAt) - new Date(app.createdAt)) / (1000 * 60 * 60 * 24);
        return acc + days;
      }
      return acc;
    }, 0) / total || 0;
    
    const responseTime = avgResponseDays.toFixed(1) + ' days';
    const satisfaction = hired > 0 ? '4.8/5' : 'N/A';
    
    return { acceptanceRate, responseTime, satisfaction };
  }, [userApplication]);

  return (
    <div className="space-y-6 pb-8 overflow-x-hidden">
      <div className="mt-8">
        <h2 className="text-3xl font-bold text-gray-800 px-4 md:px-0">Analytics Overview</h2>
      </div>

      {/* Pie Chart - Full width on all screens */}
      {pieData.length > 0 && (
        <div className="bg-white rounded-xl shadow-lg p-4 md:p-6 mx-4 md:mx-0">
          <h3 className="text-xl font-semibold mb-4 text-gray-800">Application Status Distribution</h3>
          <div className="h-64 md:h-72">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={pieData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                >
                  {pieData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}

      {/* Charts Section - Stacks vertically on mobile, side by side on lg+ */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 px-4 md:px-0">
        {/* Applications Trend */}
        <div className="bg-white rounded-xl shadow-lg p-4 md:p-6">
          <h3 className="text-xl font-semibold mb-4 text-gray-800">Applications Trends (Monthly)</h3>
          <div className="h-64 md:h-72">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={analyticsData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="applications" stroke="#f97316" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Interviews Growth */}
        <div className="bg-white rounded-xl shadow-lg p-4 md:p-6">
          <h3 className="text-xl font-semibold mb-4 text-gray-800">Interviews Growth (Monthly)</h3>
          <div className="h-64 md:h-72">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={analyticsData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="interviews" fill="#f97316" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Performance Metrics - Card view on all screens, better on mobile */}
      <div className="bg-white rounded-xl shadow-lg p-4 md:p-6 mx-4 md:mx-0">
        <h3 className="text-xl font-semibold mb-6 text-gray-800">Performance Metrics</h3>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          <div className="text-center p-4 bg-gray-50 rounded-xl">
            <p className="text-3xl font-bold text-orange-500">{performanceMetrics.acceptanceRate}</p>
            <p className="text-gray-600 mt-2 text-sm">Acceptance Rate</p>
          </div>
          <div className="text-center p-4 bg-gray-50 rounded-xl">
            <p className="text-3xl font-bold text-orange-500">{performanceMetrics.responseTime}</p>
            <p className="text-gray-600 mt-2 text-sm">Avg. Response Time</p>
          </div>
          <div className="text-center p-4 bg-gray-50 rounded-xl">
            <p className="text-3xl font-bold text-orange-500">{performanceMetrics.satisfaction}</p>
            <p className="text-gray-600 mt-2 text-sm">Success Score</p>
          </div>
        </div>
      </div>

      {/* Application Table Section */}
      <div className="bg-white rounded-lg shadow-sm p-4 md:p-6 mx-4 md:mx-0">
        <ApplicationTable userApplication={userApplication} />
      </div>
    </div>
  );
}

export default Applications;